export const API_URL = import.meta.env.VITE_APP_API_URL as string;

if (!API_URL) {
	throw new Error("VITE_APP_API_URL is not defined in environment variables");
}
